import { defineComponent as k, computed as a, withDirectives as B, openBlock as I, createBlock as V, resolveDynamicComponent as D, mergeProps as C, withCtx as N, renderSlot as P, createElementVNode as T, normalizeClass as w, unref as x } from "vue";
import { E as l } from "./chunks/EnumParser.dab943ef.js";
import { T as y } from "./chunks/Tooltip.b53afcfb.js";
import './assets/Card.css';import './assets/index46.css';/* empty css                                                      */import { F as s } from "./chunks/FrontiersIcon.fac4da01.js";
var i = /* @__PURE__ */ ((o) => (o.White = "white", o.Black = "black", o))(i || {}), r = /* @__PURE__ */ ((o) => (o.ExtraSmall = "xs", o.Small = "small", o.Medium = "medium", o.Large = "large", o))(r || {});
const z = /* @__PURE__ */ k({
  __name: "ButtonIcon",
  props: {
    label: { default: "" },
    href: {},
    target: {},
    showTooltip: { type: Boolean },
    tooltipPosition: { default: () => [] },
    icon: {},
    size: { default: "Medium" },
    color: { default: "Black" },
    isDisabled: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(o, { emit: c }) {
    const e = o, u = y, p = a(() => {
      const t = ["ButtonIcon"], n = l.getValue(i, e.color), g = l.getValue(r, e.size);
      return t.push(`ButtonIcon--${n}`), t.push(`ButtonIcon--${g}`), e.isDisabled && t.push("ButtonIcon--disabled"), t;
    }), m = a(() => {
      const t = ["ButtonIcon__icon"];
      if (e.icon) {
        const n = l.getValue(s, e.icon);
        n !== s.None && t.push(`ButtonIcon__icon--${n}`);
      }
      return t;
    }), f = a(() => e.showTooltip ? e.label : ""), d = a(() => {
      var t;
      return (t = e.tooltipPosition) == null ? void 0 : t.join(" ");
    });
    a(() => e.isDisabled === !1);
    const v = (t) => {
      e.isDisabled || c("click", t);
    }, b = a(() => e.href ? "a" : "button"), h = a(() => e.href ? "'a', 'link'" : "'btn', 'action'"), _ = a(() => {
      if (e.href)
        return {
          href: e.href,
          target: e.target || "_self"
        };
    });
    return (t, n) => B((I(), V(D(b.value), C({
      "data-tootip-position": d.value,
      class: p.value,
      "aria-label": t.label,
      "data-event": t.$ga.getDataEventValue(h.value)
    }, _.value, { onClick: v }), {
      default: N(() => [
        P(t.$slots, "default", {}, () => [
          T("span", {
            class: w(m.value)
          }, null, 2)
        ])
      ]),
      _: 3
    }, 16, ["data-tootip-position", "class", "aria-label", "data-event"])), [
      [x(u), f.value]
    ]);
  }
});
export {
  z as ButtonIcon,
  i as ButtonIconColor,
  r as ButtonIconSize
};
